import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { API_URL } from '../config';

const TawkWidget = () => {
  const location = useLocation();
  const [tawkSettings, setTawkSettings] = useState(null);

  // Fetch Tawk settings din API
  useEffect(() => {
    const fetchTawkSettings = async () => {
      try {
        const response = await fetch(`${API_URL}/api/orders/tawk`);
        const data = await response.json();
        setTawkSettings(data);
      } catch (error) {
        console.error('Error fetching Tawk settings:', error);
      }
    };

    fetchTawkSettings();
  }, []);

  // Injectare Tawk.to widget
  useEffect(() => {
    // NU încărca pe paginile admin
    if (location.pathname.startsWith('/admin')) return;

    // Verifică dacă Tawk e activat și are widgetId
    if (!tawkSettings?.enabled) return;
    if (!tawkSettings.widgetId) return;

    // Verifică dacă Tawk e deja încărcat
    if (window.Tawk_API) return;

    // Injectare script Tawk.to
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://embed.tawk.to/${tawkSettings.widgetId}/default`;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    script.id = 'tawk-script';

    // Widget position CSS (convertire position la Tawk API format)
    const positionMap = {
      'bottom-right': 'br',
      'bottom-left': 'bl',
      'top-right': 'tr',
      'top-left': 'tl'
    };

    // Configurare poziție widget (opțional - Tawk.to dashboard poate controla și el)
    window.Tawk_LoadStart = new Date();
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_API.customStyle = {
      visibility: {
        desktop: {
          position: positionMap[tawkSettings.position] || 'br',
          xOffset: 20,
          yOffset: 20
        },
        mobile: {
          position: positionMap[tawkSettings.position] || 'br',
          xOffset: 10,
          yOffset: 10
        }
      }
    };

    document.body.appendChild(script);

    // Cleanup la unmount
    return () => {
      const existingScript = document.getElementById('tawk-script');
      if (existingScript) {
        existingScript.remove();
      }
      // Remove Tawk widget
      const tawkWidget = document.getElementById('tawk-bubble-container');
      if (tawkWidget) {
        tawkWidget.remove();
      }
      delete window.Tawk_API;
      delete window.Tawk_LoadStart;
    };
  }, [tawkSettings, location.pathname]);

  // Componenta nu renderează nimic (doar side effects)
  return null;
};

export default TawkWidget;
